import { Checkbox, FormControlLabel } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";
import {
  iObjetivoAprendizaje,
  SelectedIndicator,
} from "../../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";

interface Props {
  indicador: string;
  selectedIndicators: SelectedIndicator;
  objetivo: iObjetivoAprendizaje;
  handleIndicatorSelect: (idObjetivo: string, indicador: string) => void;
  setSelectedIndicators: Dispatch<SetStateAction<SelectedIndicator>>;
  color: string;
}

const IndicadorCheckbox: FC<Props> = ({
  indicador,
  selectedIndicators,
  objetivo,
  handleIndicatorSelect,
  setSelectedIndicators,
  color,
}) => {
  const { objetivosSeleccionados } = useActividadesContext();

  const isSelected =
    selectedIndicators[objetivo.id_objetivo]?.includes(indicador) ?? false;
  const isDisabled =
    objetivosSeleccionados[objetivo.id_objetivo] && !isSelected;

  const handleChange = () =>
    handleIndicatorSelect(objetivo.id_objetivo, indicador);

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={isSelected}
          onChange={handleChange}
          disabled={isDisabled}
          sx={{
            borderRadius: "50px",
            alignSelf: "flex-start",
            mt: -1,
            "& .MuiSvgIcon-root": {
              width: "18px",
              height: "18px",
            },
            "&.Mui-checked": {
              color,
            },
          }}
        />
      }
      label={indicador}
      sx={{
      width: "100%",  
      display: "flex",
      alignItems: "flex-start",
      m: 0, 
      ".MuiFormControlLabel-label": {
        fontSize: "0.7rem",
        color,
        fontFamily: "Montserrat",
        mb: 3,
      },
    }}
    />
  );
};

export default IndicadorCheckbox;
